export const REDUCER_NAME="fbCampaignSlice";

export interface ifbCampaignDTO {
    id?: string;
    name?: string;
    Objective?: string;
    status?: string;
    created_time?: string; 
    special_ad_categories: string[];
    is_adset_budget_sharing_enabled: boolean;  
}

export interface ifbCampaignState {
    fbCampaignList: ifbCampaignDTO[] | null;
    isLoading: boolean;
    errorMessage: string | null;
}